export enum CalCategoryIcon {
    PERSONAL = "fa fa-user",
    IMPORTANT = "fa fa-star",
    CAR = "fa fa-car",
    INVITATION = "fa fa-envelope",
}
